import Resource from './Resource';

export default class Help extends Resource {
	constructor(options={}) {
		let {
			query = {},
			data = {}
		} = options;

		let route = 'help';

		let config = {
			route: route,
			query: query,
			data: data,
		};

		super(config);
		return this;
	}

	get() {
		return this.request();
	}
}
